import type { AuthUser } from '@aibees/shared/definition';
import { AI_BEES_EMAIL_DOMAINS } from '../constants/posthog';
import type { User, UserRelation } from '../definition';
import { joinStrings } from './string';

export function userGetFullName(
  user?: User | UserRelation | AuthUser | null,
  defaultName: string | 'username' = ''
) {
  return user
    ? joinStrings(user.firstName, user.lastName, ' ') || defaultName
    : defaultName;
}

export function userGetShortName(
  user?: User | UserRelation | AuthUser | null
): string {
  if (!user) return '';

  const fullName = userGetFullName(user);
  if (!fullName) return '';

  const nameParts = fullName.trim().split(/\s+/);

  if (nameParts.length === 1) {
    return nameParts[0];
  }

  // First name + first letter of second name with period
  return `${nameParts[0]} ${nameParts[1].charAt(0).toUpperCase()}.`;
}

export function isAIBeesUser(email?: string | null): boolean {
  if (!email || typeof email !== 'string') {
    return false;
  }

  return AI_BEES_EMAIL_DOMAINS.some((domain) => email.endsWith(domain));
}
